import React from "react";
import { useT } from "@/hooks/useT";

/**
 * `<details>` disclosure for the technical explanation of the stamping
 * pipeline. Closed by default; keyboard-accessible via the native
 * disclosure semantics.
 */
export function TechnicalDetails() {
  const { t } = useT("verifiedDocuments");
  const calendars = t("technical.calendars", { returnObjects: true });

  return (
    <section
      className="border-t border-hairline py-16 md:py-20"
      data-testid="verified-technical"
    >
      <div className="mx-auto max-w-4xl px-6">
        <details className="group rounded-[16px] border border-hairline bg-[rgba(21,10,36,0.4)] p-6">
          <summary
            className="flex cursor-pointer list-none items-center justify-between text-base font-semibold text-ink-primary transition-colors duration-fast ease-out hover:text-frac-violet focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-frac-violet focus-visible:ring-offset-2 focus-visible:ring-offset-surface-base"
            data-testid="verified-technical-summary"
          >
            <span>{t("technical.summary")}</span>
            <span
              aria-hidden
              className="ml-4 inline-flex h-6 w-6 items-center justify-center rounded-full border border-hairline text-ink-secondary transition-transform duration-base ease-out group-open:rotate-45"
            >
              <span className="block h-px w-3 bg-current" />
              <span className="absolute block h-3 w-px bg-current" />
            </span>
          </summary>

          <div className="mt-6 space-y-4 text-sm leading-relaxed text-ink-secondary">
            <p>{t("technical.intro")}</p>
            <p>{t("technical.ots")}</p>

            <div>
              <p className="text-[11px] font-semibold uppercase tracking-caps text-ink-tertiary">
                {t("technical.calendarsHeading")}
              </p>
              <ul className="mt-2 space-y-1">
                {Array.isArray(calendars) &&
                  calendars.map((url) => (
                    <li key={url} className="font-mono text-[12px] text-ink-primary">
                      {url}
                    </li>
                  ))}
              </ul>
            </div>

            <p>{t("technical.independentCheck")}</p>
          </div>
        </details>
      </div>
    </section>
  );
}

export default TechnicalDetails;
